var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require('@/assets/no-results.svg')}}),_vm._v("\n  No data available\n")])}
var staticRenderFns = []

export { render, staticRenderFns }